import React from "react";
import { useSettings } from "@/context/SettingsContext";

/**
 * Dynamic brand logo and lockup.
 * Uses the uploaded JPG from site settings; falls back to inline navy "P".
 */
export function BrandMark({ className = "h-9 w-9" }) {
  const { settings } = useSettings();
  const url = settings?.logo_url || "/pilotyatra-logo.jpg";
  return (
    <img
      src={url}
      alt={settings?.site_name || "PilotYatra"}
      className={`${className} rounded-md object-contain`}
      onError={(e) => { e.currentTarget.style.display = "none"; }}
      draggable={false}
    />
  );
}

export function BrandLogo({ className = "h-10", showTag = true }) {
  const { settings } = useSettings();
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <BrandMark className="h-10 w-10" />
      <div className="flex flex-col leading-none">
        <div className="font-display text-xl font-extrabold tracking-tight">
          <span className="text-[hsl(var(--brand-navy))]">Pilot</span>
          <span className="text-[hsl(var(--brand-orange))]">Yatra</span>
        </div>
        {showTag && (
          <div className="hidden text-[10px] font-semibold uppercase tracking-[0.18em] text-muted-foreground sm:block">
            {settings?.tagline || "Your Journey to the Cockpit"}
          </div>
        )}
      </div>
    </div>
  );
}
